import { useContext } from 'react';

import { ErrorContext } from './ErrorProvider';

const useError = () => {
  const ctx = useContext(ErrorContext);
  if (ctx === null) {
    throw new Error('useError must be used within a ErrorProvider!');
  }

  return ctx;
};

export default useError;
